module.exports = __webpack_public_path__ + "static/media/Taken.55e79e28.svg";